export const presentsSliderOptions = (instance, options) => {
    let responsiveItemCounts = {
        1024: 4,
    }

    let breakpoints = {}

    for (const resolution in responsiveItemCounts) {
        const count = responsiveItemCounts[resolution]

        breakpoints[resolution] = {
            slidesPerView: count,
            slidesPerGroup: count,
            spaceBetween: 40,
            cssMode: false,
            pagination: {
                dynamicBullets: false,
            }
        }
    }

    return {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 20,
        cssMode: true,
        breakpoints: breakpoints
    }
}